import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconSearch = (props) => {
  props = Object.assign({viewBox: '0 0 32 32'}, props);
  return (
    <SvgIcon {...props}>
      <path
        d="M22.4 24.6c-5.667 4.4-13.6 3.2-17.8-2.067-4.133-5.133-3.733-12.467 0.867-17.067 4.6-4.667 11.933-5.067 17.067-0.933 5.267 4.2 6.467 12.133 2 17.933 0.133 0.067 0.267 0.133 0.333 0.2 2.6 2.6 2.267 2.333 4.8 4.867 0.267 0.267 0.533 0.6 0.533 1 0.067 0.667-0.267 1.267-0.867 1.6-0.6 0.267-1.267 0.2-1.733-0.267-0.8-0.8-1.6-1.6-2.4-2.4-1.867-1.867-0.8-0.867-2.667-2.733 0-0.067-0.067-0.067-0.133-0.133zM14.533 4.8c-5.4 0-9.733 4.333-9.733 9.733 0 5.333 4.4 9.667 9.733 9.667s9.667-4.4 9.667-9.733c0-5.333-4.333-9.667-9.667-9.667z"/>
    </SvgIcon>
  );
};

IconSearch.displayName = 'IconSearch';
IconSearch.muiName = 'SvgIcon';

export default IconSearch;



// WEBPACK FOOTER //
// ./src/components/Icons/IconSearch.js